/**
 * Třída slouží pro obalení seznamu položek v Card komponentě, položkou seznamu je typicky CardBlock.
 *
 * Použití:
 * <Card>
 *   <CardHeader>Hlavicka</CardHeader>
 *   <CardBlock>nejaky obsah...</CardBlock>
 *   <CardItems>
 *       <CardBlock>polozka seznamu 1</CardBlock>
 *       <CardBlock>polozka seznamu 2</CardBlock>
 *       <CardBlock>polozka seznamu 3</CardBlock>
 *   </CardItems>
 * </Card>
 */
import React from 'react';
import classNames from 'classnames';
import AbstractReactComponent from "../AbstractReactComponent";

export default class CardItems extends AbstractReactComponent {
    static propTypes = {
        bordered: React.PropTypes.bool,   // pokud je true, jsou položky zobrazeny s okrajem, standardně je false
    };

    static defaultProps = {
        bordered: false
    };

    render() {
        const {className, bordered} = this.props;

        const cls = classNames(
            "items-list",
            className, {
                bordered
            }
        );

        return (
            <div className={cls}>
                {this.props.children}
            </div>
        );
    }
};
